import useDaiAccess from '../../hooks/useDaiAccess'
import { AccessDenied } from '@eggplant/embedded-documentation'

const DaiAccessDenied = () => {
  const [isAccess] = useDaiAccess(['dai:user'])

  return (
    <AccessDenied isUser={isAccess} />
  )
}

export default DaiAccessDenied
